import { render, staticRenderFns } from "./AdmStats.vue?vue&type=template&id=1ffb427d&scoped=true&"
import script from "./AdmStats.vue?vue&type=script&lang=js&"
export * from "./AdmStats.vue?vue&type=script&lang=js&"
import style0 from "./AdmStats.vue?vue&type=style&index=0&id=1ffb427d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ffb427d",
  null
  
)

export default component.exports